import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import {
  FETCH_ALL_ORDER_TRANSACTION,
  FETCH_USER_ORDER_TRANSACTIONS,
  FETCH_ID_ORDER_TRANSACTIONS,
} from '../actions/order_transaction/action_types';

import actions from '../actions/order_transaction';
import rf from '../../requests/RequestFactory';

// saga effect

function* fetchAllOrderTransaction(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('OrderTransactionRequest').fetchAllOrderTransaction(params), action.params.data);
    yield put(actions.fetchAllOrderTransactionActionSucceed(data));
  } catch (err) {
    yield put(actions.fetchAllOrderTransactionActionFailed(err));
  }
}

function* fetchUserOrderTransactions(action) {
  try {
    const resp = yield call((params) => rf.getRequest('OrderTransactionRequest').fetchUserOrderTransactions(params), action.params.data);
    yield put(actions.fetchUserOrderTransactionsActionSucceed(resp.data));
    if (window._.isFunction(action.callback)) {
      yield action.callback(resp.total_count || 0);
    }
  } catch (err) {
    yield put(actions.fetchUserOrderTransactionsActionFailed(err));
  }
}

function* fetchIdOrderTransactions(action) {
  try {
    const resp = yield call((params) => rf.getRequest('OrderTransactionRequest').fetchIdOrderTransactions(params), action.params.data);
    yield put(actions.fetchIdOrderTransactionsActionSucceed(resp.data));
    if (window._.isFunction(action.callback)) {
      yield action.callback(resp.data);
    }
  } catch (err) {
    yield put(actions.fetchIdOrderTransactionsActionFailed(err));
  }
}

function* watchAllOrderTransactions() {
  yield takeLatest(FETCH_ALL_ORDER_TRANSACTION, fetchAllOrderTransaction);
  yield takeLatest(FETCH_USER_ORDER_TRANSACTIONS, fetchUserOrderTransactions);
  yield takeLatest(FETCH_ID_ORDER_TRANSACTIONS, fetchIdOrderTransactions);
}

export default function* rootSaga() {
  yield all([fork(watchAllOrderTransactions)]);
}
